export const setImgRatioHeight = (ratioString, fixedWidth = 384) => {
  const ratioMapping = {
    '11': '1:1',
    '12': '1:2',
    '21': '2:1',
    '23': '2:3',
    '32': '3:2',
    '34': '3:4',
    '45': '4:5',
    '54': '5:4',
    '916': '9:16',
    '43': '4:3',
    '169': '16:9'
  };
  const [widthRatio, heightRatio] = ratioMapping[ratioString].split(':');
  return fixedWidth / widthRatio * heightRatio;
}
export const getRatioValueWithString = (ratioString) => {
  const ratioNumberMapping = {
    '11': 1,
    '12': 1/2,
    '21': 2,
    '23': 2/3,
    '32': 3/2,
    '34': 3/4,
    '45': 4/5,
    '54': 5/4,
    '916': 9/16,
    '43': 4/3,
    '169': 16/9,
  };
  return ratioNumberMapping[ratioString] || 2/3;
}
